import { Tooltip, Box, Typography } from '@mui/material';
import { theme } from 'config/theme';
import BroadcastFillIcon from 'remixicon-react/BroadcastFillIcon';
import InformationLineIcon from 'remixicon-react/InformationLineIcon';

function AddPostBanner() {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 600,
            padding: 0,
            backgroundColor: theme.palette.custom.white,
            boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
            border: `1px solid ${theme.palette.custom.divider}}`,
            borderRadius: '16px',
          },
        },
        arrow: {},
      }}
      PopperProps={{
        sx: (theme) => ({
          '& .MuiTooltip-tooltip': {
            mb: '16px !important',
          },
        }),
      }}
      title={
        <Box onClick={(event) => event.stopPropagation()}>
          <Box
            sx={{
              '& .insight': {
                width: '36px',
                height: '36px',
                '& g': {
                  '& path': {
                    fill: '#FFDB6F',
                  },
                },
                '& path': {
                  fill: '#B38705',
                },
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  position: 'relative',
                  width: 80,
                  height: 100,
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '100%',
                    height: '100%',
                    bgcolor: theme.palette.custom.earlyDawn,
                    borderTopRightRadius: '100% 100%',
                    borderBottomRightRadius: '100% 100%',
                    zIndex: 0,
                  }}
                />
                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  <BroadcastFillIcon className="insight" />
                </Box>
              </Box>
              <Box px={3}>
                <Typography
                  fontSize={18}
                  fontWeight={700}
                  mb={1}
                  sx={(theme) => ({
                    color: theme.palette.custom.tuna,
                  })}
                >
                  Add knowledge directly to the feed.
                </Typography>
                <Typography
                  sx={(theme) => ({
                    fontStyle: 'italic',
                    mt: 1,
                    color: theme.palette.custom.mistBlue,
                    fontSize: 14,
                  })}
                >
                  Tip: Use this for timely and widely applicable information.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      }
      placement="top-end"
    >
      <Box>
        <InformationLineIcon size={18} />
      </Box>
    </Tooltip>
  );
}

export default AddPostBanner;
